// components/Dashboard/api.js
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

// Get authorization token from localStorage
const getAuthToken = () => {
  return localStorage.getItem("token");
};

// Get user info from localStorage
const getUserInfo = () => {
  const userStr = localStorage.getItem("user");
  return userStr ? JSON.parse(userStr) : null;
};

// API instance with auth header
const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add auth token to requests
api.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Users Management API
export const usersAPI = {
  // Get all users
  getAllUsers: async () => {
    try {
      const response = await api.get("/auth/users");
      return response.data;
    } catch (error) {
      console.error("Error fetching users:", error);
      throw error.response?.data || { message: "Failed to fetch users" };
    }
  },

  // Approve user
  approveUser: async (userId) => {
    try {
      const response = await api.put(`/auth/users/${userId}/approve`);
      return response.data;
    } catch (error) {
      console.error("Error approving user:", error);
      throw error.response?.data || { message: "Failed to approve user" };
    }
  },

  // Disapprove user
  disapproveUser: async (userId) => {
    try {
      const response = await api.put(`/auth/users/${userId}/disapprove`);
      return response.data;
    } catch (error) {
      console.error("Error disapproving user:", error);
      throw error.response?.data || { message: "Failed to disapprove user" };
    }
  },

  // Delete user
  deleteUser: async (userId) => {
    try {
      const response = await api.delete(`/auth/users/${userId}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting user:", error);
      throw error.response?.data || { message: "Failed to delete user" };
    }
  },

  // Check if current user is admin
  isAdmin: () => {
    const user = getUserInfo();
    return user?.role === "admin";
  },
};

export default api;
